// LoadingIndicator.tsx
import React from 'react';
import { Rings } from 'react-loader-spinner';

const LoadingIndicator: React.FC = () => {
  return (
    <div className="flex justify-center items-center w-full h-full">
      <Rings
        height="100"
        width="100"
        color="black"
        ariaLabel="loading-indicator"
      />
    </div>
  );
};

export default LoadingIndicator;
